module.exports = __webpack_public_path__ + "img/ka.a3287fec.png";